import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { DIALOG_TYPE } from '../../../../constants/DialogTypes';
import { Button as CommonButton } from '../../../../ui/components/Common/Buttons/Button';

interface IBillingActionBarProps {
  isSaveDisabled: boolean;
  onSave: () => void;
}

export const BillingActionBar: React.FC<IBillingActionBarProps> = ({ isSaveDisabled, onSave }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: 'space-between',
      alignItems: { sm: 'center' },
      gap: 2,
    }}
  >
    <Typography variant="h4" sx={{ fontWeight: 900, color: 'text.primary', letterSpacing: '-0.03em' }}>
      Manage Licenses & Subscriptions
    </Typography>
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Button
        variant="text"
        sx={{
          px: 3,
          py: 1,
          borderRadius: 3,
          fontWeight: 700,
          textTransform: 'none',
          color: 'text.secondary',
          '&:hover': { bgcolor: 'action.hover' },
        }}
      >
        Cancel
      </Button>
      <Tooltip
        title={isSaveDisabled ? 'Fill in start & end dates for all active licenses to save.' : ''}
        arrow
      >
        <span>
          <Button
            variant="contained"
            disabled={isSaveDisabled}
            onClick={onSave}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 3,
              fontWeight: 700,
              textTransform: 'none',
              boxShadow: 2,
            }}
          >
            Save Changes
          </Button>
        </span>
      </Tooltip>
    </Stack>
  </Box>
);

export const SuspendOrganizationCard: React.FC = () => (
  <Paper
    variant="outlined"
    sx={{
      p: { xs: 3, md: 4 },
      borderRadius: 4,
      borderColor: 'error.light',
      bgcolor: 'rgba(239, 68, 68, 0.02)',
    }}
  >
    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.01em', mb: 1 }}>
      Administrative Actions
    </Typography>
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: { md: 'center' },
        gap: 3,
      }}
    >
      <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
        Suspend access immediately for this organization. This will affect all users.
      </Typography>
      <CommonButton
        label="Suspend Organization"
        variant="primary"
        dialogType={DIALOG_TYPE.ERROR}
        sx={{ borderRadius: 3, px: 4, py: 1.5, fontWeight: 700, boxShadow: "0 10px 15px -3px rgba(244, 63, 94, 0.2)" }}
      />
    </Box>
  </Paper>
);
